import {useTranslation} from 'react-i18next';
import {useTheme} from 'styled-components';
import {OFFER_CONFIRMATION_TYPES} from '@chekin/core';
import {StyledButton} from './styled';

type Props = {
  type: OFFER_CONFIRMATION_TYPES;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};
const AddToCartButton = ({className, disabled, onClick}: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <StyledButton
      className={className}
      disabled={disabled}
      onClick={onClick}
      iconName="shoppingCart"
      iconProps={{
        color: theme.colors.buttons.mainButtonTextBackground,
        position: 'left',
      }}
      label={t('book_experience_view.add_to_cart_button')}
    />
  );
};

export {AddToCartButton};
